import React from 'react';
import PropTypes from 'prop-types';

import {Grid2 as Grid} from 'views/components';
import {CompactCardTable} from 'views/module';

import Card from './Card';

const List = (props) => {
  const data = props.data;
  const isLoading = props.isLoading;
  const loadMore = props.loadMore;
  const hasMore = props.hasMore;

  return (
    <Grid container>
      <CompactCardTable
        data={data}
        card={Card}
        isLoading={isLoading}
        loadMore={loadMore}
        hasMore={hasMore}
        getItemId={(item) => item.clientId}
      />
    </Grid>
  );
};
List.propTypes = {
  data: PropTypes.array.isRequired,
  hasMore: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadMore: PropTypes.func,
};

export default React.memo(List);
